import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ToastContainer } from 'react-toastify';
import AppRoutes from '../routes/AppRoutes';
import Loader from './Loader';
import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { initializeAuthFromToken } from '@application/features/auth/authSlice';
import LocalStorageService from '@application/common/local-storage-service';
import NotificationsInitializer from './NotificationsInitializer';
import { useCompanyTheme } from '@ui/hooks/useCompanyTheme';
import { getAllLanguagesAsync } from '@application/features/languages/languagesThunk';
import i18n from '@application/utilities/i18n';
const HappinessEMAuthentication = () => {
    const dispatch = useAppDispatch();
    const { currentUser } = useAppSelector((state) => state.auth);
    const { languages } = useAppSelector((state) => state.languages);
    const languageChangedRef = useRef(null);
    // Initialize company theme based on user's primary company
    useCompanyTheme();
    // Initialize auth state from token on app startup
    useEffect(() => {
        const accessToken = LocalStorageService.getAccessToken();
        if (accessToken) {
            dispatch(initializeAuthFromToken());
        }
    }, [dispatch]);
    // Load languages on component mount
    useEffect(() => {
        dispatch(getAllLanguagesAsync());
    }, [dispatch]);
    // Also load languages when currentUser is set (in case login happened before languages loaded)
    useEffect(() => {
        if (currentUser?.primaryLanguageId && (!languages || languages.length === 0)) {
            dispatch(getAllLanguagesAsync());
        }
    }, [currentUser?.primaryLanguageId, languages, dispatch]);
    // Reset language changed ref when user changes (logout/login)
    useEffect(() => {
        if (!currentUser) {
            languageChangedRef.current = null;
        }
    }, [currentUser]);
    // Change language based on user's primary language when user logs in or language data is available
    useEffect(() => {
        if (currentUser?.primaryLanguageId && languages && languages.length > 0) {
            const userLanguage = languages.find((lang) => lang.id === currentUser.primaryLanguageId);
            if (userLanguage?.code) {
                // Normalize language code (e.g., "EN" -> "en", "nl-NL" -> "nl")
                const normalizedCode = userLanguage.code.toLowerCase().split('-')[0];
                // Only change if it's a valid language code and we haven't already changed to this language for this user
                if ((normalizedCode === 'en' || normalizedCode === 'nl' || normalizedCode === 'de') &&
                    languageChangedRef.current !== currentUser.primaryLanguageId) {
                    // Always change to user's primary language on login
                    // This ensures the language is set correctly regardless of browser/default settings
                    i18n.changeLanguage(normalizedCode).then(() => {
                        languageChangedRef.current = currentUser.primaryLanguageId || null;
                    }).catch((error) => {
                        console.error('Failed to change language:', error);
                    });
                }
            }
        }
    }, [currentUser?.primaryLanguageId, languages, currentUser]);
    // const navigate = useNavigate();
    // const dispatch = useAppDispatch();
    // const { currentUser } = useAppSelector((state) => state.auth);
    // const [loginAssured, setLoginAssured] = useState<boolean>(false);
    // useEffect(() => {
    //   const authorizeUser = async () => {
    //     try {
    //       // Check if we already have a current user
    //       if (currentUser) {
    //         setLoginAssured(true);
    //         return;
    //       }
    //       // If no current user, just allow the UI to show without making API calls
    //       // The Login component will handle the token exchange
    //       setLoginAssured(true);
    //     } catch (error) {
    //       console.error('Authentication failed:', error);
    //       setLoginAssured(true);
    //     }
    //   };
    //   authorizeUser();
    // }, [dispatch, navigate, currentUser]);
    // if (!loginAssured) return <></>;
    // Only render AppRoutes if we have a valid currentUser
    // This prevents loading app components (like Home) when user isn't authenticated
    // if (!currentUser) {
    //   console.log('HappinessEMAuthentication: No currentUser, not rendering app routes');
    //   return <></>;
    // }
    return (_jsxs(_Fragment, { children: [_jsx(Loader, {}), _jsx(NotificationsInitializer, {}), _jsx(AppRoutes, {}), _jsx(ToastContainer, { position: 'top-right', autoClose: 5000, hideProgressBar: false, newestOnTop: true, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, theme: 'colored' })] }));
};
export default HappinessEMAuthentication;
